import React, { useState } from 'react'
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import IButtonComponent from '../iComponents/iButton/IButton';
export const MultiColor = ({ TextLabel, updateColors, name, isMulti }: any) => {

    const [color, setColor] = useState("")
    return (
        <>
            <div className='flex'>
                <p style={{ fontSize: '1.3em' }}>
                    <b>
                        <p>{TextLabel}</p>
                    </b>
                </p>
                <Input
                    type="color"
                    className="cursor-pointer inputsDashboardColors"
                    placeholder={'prueba'}
                    plaintext={true}
                    value={color}
                    onChange={(e: any) => {
                        setColor(e.target.value)
                    }}
                />
                
                <IButtonComponent
                    disabled={false}
                    className="button-filter-margin0"
                    actionOnClick={() => {
                        if (color != "") {
                            updateColors(color, name, isMulti)
                        }
                    }}
                    label={'Add color'}
                    btnIcon={'bx bx-edit-alt'}
                ></IButtonComponent>


            </div>



        </>
    )
}

MultiColor.propTypes = {
    updateColors: PropTypes.func,
    name: PropTypes.string,
    isMulti: PropTypes.bool,
    TextLabel: PropTypes.string
};

export default MultiColor;